import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route,  useLocation, useNavigate} from "react-router-dom";
import { 
  LoginPage, SignupPage, ActivationPage, HomePage, ProductsPage, BestSellingPage,  FAQPage, CustomEnquiry,
  CheckoutPage, PaymentPage, OrderSuccessPage, ProductDetailsPage, ProfilePage, ShopCreatePage, SellerActivationPage,UserActivationPage, 
  ShopLoginPage, OrderDetailsPage, TrackOrderPage,  ForgotPassword, ResetPassword, ShopForgotPassword, 
  ShopResetPassword, 
  ContactUsPage
} from "./routes/Routes";
import { 
  ShopDashboardPage, ShopCreateProduct, ShopEditProduct, ShopAllProducts, 
  ShopAllCoupouns,  ShopAllOrders, ShopOrderDetails, ShopAllRefunds, ShopSettingsPage, 
    ShopAccountTransactions 
} from "./routes/ShopRoutes"; 
import { 
  AdminDashboardPage, AdminDashboardUsers,AdminSellerProducts, AdminDashboardSellers, AdminDashboardOrders, AdminDashboardSales,  
  AdminOrderDetailsPage, AdminSellerTransactions,AdminUserTransactions, AdminCreateInvoice, AdminEditInvoice, AdminCreateSellerInvoice, AdminViewSellerInvoices, AdminEditSellerInvoice
} from "./routes/AdminRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Store from "./redux/store";
import { loadSeller, loadUser } from "./redux/actions/user";
import ProtectedRoute from "./routes/ProtectedRoute";
import ProtectedAdminRoute from "./routes/ProtectedAdminRoute";
import SellerProtectedRoute from "./routes/SellerProtectedRoute"; 
import { getAllProducts } from "./redux/actions/product";
import { initGA, logPageView } from "./analytics/ga4";
import { Helmet } from "react-helmet";

import SearchResultsPage from './pages/SearchResultsPage';

const App = () => {
  useEffect(() => {
    // Initialize app data in parallel for faster loading
    const initializeApp = async () => {
      try {
        // Load user/seller data and products in parallel
        await Promise.all([
          Store.dispatch(loadUser()),
          Store.dispatch(loadSeller()),
          Store.dispatch(getAllProducts())
        ]);
      } catch (error) {
        console.error('App initialization error:', error);
      }
    };

    initializeApp();
    initGA();
    logPageView();
  }, []);

  const GAListener = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
  
    useEffect(() => {
      logPageView();
    }, [location]);

    // Handle redirect from backend (either sessionStorage or URL parameter)
    useEffect(() => {
      // First check URL parameter (from meta refresh)
      const urlParams = new URLSearchParams(window.location.search);
      const redirectParam = urlParams.get('redirect');
      
      if (redirectParam && redirectParam !== window.location.pathname) {
        console.log('Navigating to redirect param:', redirectParam);
        // Clean up URL and navigate
        window.history.replaceState({}, '', '/');
        navigate(redirectParam, { replace: true });
        return;
      }
      
      // Fallback to sessionStorage (for older implementations)
      const targetPath = sessionStorage.getItem('targetPath');
      if (targetPath && targetPath !== window.location.pathname) {
        console.log('Navigating to stored targetPath:', targetPath);
        sessionStorage.removeItem('targetPath');
        navigate(targetPath, { replace: true });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Run once on mount
  
    return children;
  };

  // Don't block rendering - let components handle their own loading states
  return (
    <BrowserRouter> 
       <GAListener>
       <Helmet>
          <meta name="google-site-verification" content="p1ejt899XBc-yQugL2o1eZS_Opy6ItSEz8GKPDK2Wno" />
          {/* Global Meta Tags */}
          <meta charSet="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="description" content="Hawler is Mutiproduct industrial Marketplace in India, offering a wide range of products from multiple vendors." />
          <title>Hawler - Your Trusted Mutiproduct industrial Marketplace in India</title>
          {/* Open Graph Tags */}
          <meta property="og:title" content="Hawler - Your Trusted Mutiproduct industrial Marketplace in India" />
          <meta property="og:description" content="Discover a wide range of products from multiple vendors at Hawler. Serving Coimbatore and troughout India with quality and affordability." />
          <meta property="og:image" content="https://res.cloudinary.com/dj1w38zh5/image/upload/v1727440595/avatars/logo_vpr0jm.png" />
          <meta property="og:url" content="https://www.hawler.co.in/" />
          <meta property="og:type" content="website" />
        </Helmet>
      <Routes> 
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sign-up" element={<SignupPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/activation/:activation_token" element={<ActivationPage />} />
        <Route path="/seller/activation/:activation_token" element={<SellerActivationPage />} />
        <Route path="/user/activate-account/:activation_token" element={<UserActivationPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/product/:id" element={<ProductDetailsPage />} />
        <Route path="/best-selling" element={<BestSellingPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/custom-enquiry" element={<CustomEnquiry />} />
        <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
        <Route path="/payment" element={<ProtectedRoute><PaymentPage /></ProtectedRoute>} />
        <Route path="/order/success" element={<OrderSuccessPage />} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/user/order/:id" element={<ProtectedRoute><OrderDetailsPage /></ProtectedRoute>} />
        <Route path="/user/track/order/:id" element={<ProtectedRoute><TrackOrderPage /></ProtectedRoute>} />
        <Route path="/shop-create" element={<ShopCreatePage />} />
        <Route path="/shop-login" element={<ShopLoginPage />} /> 
        <Route path="/settings" element={<SellerProtectedRoute><ShopSettingsPage /></SellerProtectedRoute>} />
        <Route path="/dashboard" element={<SellerProtectedRoute><ShopDashboardPage /></SellerProtectedRoute>} />
        <Route path="/dashboard-create-product" element={<SellerProtectedRoute><ShopCreateProduct /></SellerProtectedRoute>} />
        <Route path="/edit-product/:id" element={<SellerProtectedRoute><ShopEditProduct /></SellerProtectedRoute>} />
        <Route path="/dashboard-orders" element={<SellerProtectedRoute><ShopAllOrders /></SellerProtectedRoute>} />
        <Route path="/dashboard-refunds" element={<SellerProtectedRoute><ShopAllRefunds /></SellerProtectedRoute>} />
        <Route path="/order/:id" element={<SellerProtectedRoute><ShopOrderDetails /></SellerProtectedRoute>} />
        <Route path="/dashboard-products" element={<SellerProtectedRoute><ShopAllProducts /></SellerProtectedRoute>} />
        <Route path="/dashboard-shop-account-transactions" element={<SellerProtectedRoute><ShopAccountTransactions /></SellerProtectedRoute>} />
        <Route path="/dashboard-coupouns" element={<SellerProtectedRoute><ShopAllCoupouns /></SellerProtectedRoute>} />
        <Route path="/admin/dashboard" element={<ProtectedAdminRoute><AdminDashboardPage /></ProtectedAdminRoute>} />
        <Route path="/admin-users" element={<ProtectedAdminRoute><AdminDashboardUsers /></ProtectedAdminRoute>} />
        <Route path="/admin-sellers" element={<ProtectedAdminRoute><AdminDashboardSellers /></ProtectedAdminRoute>} />
        <Route path="/admin-create-invoice" element={<ProtectedAdminRoute><AdminCreateInvoice /></ProtectedAdminRoute>} />
        <Route path="/admin-edit-invoice/:id" element={<ProtectedAdminRoute><AdminEditInvoice /></ProtectedAdminRoute>} />
        <Route path="/admin-edit-seller-invoice/:id" element={<ProtectedAdminRoute><AdminEditSellerInvoice /></ProtectedAdminRoute>} />
        <Route path="/admin-orders" element={<ProtectedAdminRoute><AdminDashboardOrders /></ProtectedAdminRoute>} />
        <Route path="/admin-sales" element={<ProtectedAdminRoute><AdminDashboardSales /></ProtectedAdminRoute>} />
        <Route path="/admin-create-seller-invoice" element={<ProtectedAdminRoute><AdminCreateSellerInvoice /></ProtectedAdminRoute>} />
        <Route path="/admin-seller-invoices" element={<ProtectedAdminRoute><AdminViewSellerInvoices /></ProtectedAdminRoute>} />
        <Route
    path="/admin/seller-products/:sellerId"
    element={<ProtectedAdminRoute><AdminSellerProducts /></ProtectedAdminRoute>}
  />
        <Route path="/admin/order/:id" element={<ProtectedAdminRoute> < AdminOrderDetailsPage /></ProtectedAdminRoute>} />

        <Route
  path="/admin/seller-transactions/:sellerId"
  element={<ProtectedAdminRoute><AdminSellerTransactions /></ProtectedAdminRoute>}
/>

<Route
  path="/admin/user-transactions/:userId"
  element={<ProtectedAdminRoute><AdminUserTransactions /></ProtectedAdminRoute>}
/>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/shop-forgot-password" element={<ShopForgotPassword />} />
        <Route path="/shop-reset-password/:token" element={<ShopResetPassword />} />
        <Route path="/search" element={<SearchResultsPage />} />
      </Routes>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      </GAListener>
    </BrowserRouter>
  );
};

export default App;
